//React components
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
//Components 
import Navbar from './Nav/NavBar';
import TransactionHistory from "../transactions/TransactionHistory";
import SuccessAlert from '../Alerts/SuccessAlert';
import ErrorAlert from '../Alerts/ErrorAlert';
import Modal from 'react-bootstrap/Modal';
import validSession from '../utils/validSession';
//Internal components 
import ReportTable from '../reports/table/ReportTable';
import OrderDetails from '../Orders/OrderDetails';
//API
import { OrdersFetchAPI } from '../../api/Orders';
//We import the process payment function
import { PaymentOperations } from '../../utils/PaymentOperations';
//img
import empty from '../img/icons/empty.png'
import logo_sp from '../../assets/img/logos/icon-black.png';
//Utils 
import { RenderIf } from '../utils/RenderIf';
import {
  KINPOS_INTEGRATION_ID,
  isGenericSettlementIntegrationId,
  isKinposClosePending,
  isKinposEmptyInformZError,
  isKinposIntegrationId,
  kinposPaymentBridge,
  toKinposCloseRecord,
} from '../../utils/KinposBridge';

//External modules 
import moment from 'moment-timezone';
import LoadingAlert from '../Alerts/LoadingAlert';

//Socket 
import Socket from '../utils/Socket.config';
//Alerts 
let kinposCloseInvocationInProgress = false;

function AnaliticsPayment() {
  //Params
  let { business_code, branchoffice_code } = useParams();
  let selectedBranch = branchoffice_code
  //We get the user data 
  let user = localStorage.getItem('user');
  let token = localStorage.getItem('x-access-token');
  let generalData = localStorage.getItem('generalData');
  let machine = JSON.parse(localStorage.getItem('machine'));
  //We validate if the user is logged in
  if (user === null || user === undefined || user === '' || user === 'null') {
    user = {
      name: 'No registrado',
      img: 'https://www.pngitem.com/pimgs/m/30-307416_profile-icon-png-image-free-download-searchpng-employee.png'
    }
  } else {
    user = JSON.parse(localStorage.getItem('user'))
  }

  //States
  const [branchOrdersData, setBranchOrdersData] = useState([]);
  const [branchAnaliticsData, setBranchAnaliticsData] = useState([]);
  const [temporal, setTemporal] = useState([]);
  const [minDate, setMinDate] = useState(new Date().toJSON().slice(0, 10));
  const [userBranchoffices, setUserBranchs] = useState([]);
  //const [selectedBranch, setSelectedBranch] = useState({code: 0});
  const [totalOrders, setTotalOrders] = useState(0)
  const [subtotalOrders, setSubtotalOrders] = useState(0)
  const [taxOrders, setTaxOrders] = useState(0)

  const [ordersPaymentMethod, setOrdersPaymentMethod] = useState([])
  const [modalShow, setModalShow] = useState(false);
  const [modalShowDetail, setModalShowDetail] = useState(false);
  const [modalInformZSettleInfo, setModalInformZSettleInfo] = useState(false);
  const [modalInformZSettle, setModalInformZSettle] = useState(false);
  const [detailOrder, setDetailOrder] = useState();
  const [order_type, setOrderType] = useState("temporal");
  const [userBusiness, setUserBusiness] = useState({});
  const [reload, setReLoad] = useState();
  const [kinposClosePending, setKinposClosePending] = useState(() => (
    isKinposClosePending(kinposPaymentBridge.getPendingPayment())
  ));
  const kinposCloseResultHandlerRef = useRef(null);
  const getSettlementContextRef = useRef(null);
  const syncKinposClosePendingRef = useRef(null);
  const updateOrdersInformZRef = useRef(null);
  const syncKinposClosePending = () => {
    const closePending = isKinposClosePending(kinposPaymentBridge.getPendingPayment());
    setKinposClosePending(closePending);
    return closePending;
  };
  syncKinposClosePendingRef.current = syncKinposClosePending;

  //Variables
  //We get the actual date 
  const actualDate = moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD')
  //We put the actual date in rank of all the day 
  const maxDate = actualDate + 'T23:59:59.000+00:00';

  const getSettlementContext = (initialDateOverride, finalDateOverride) => {
    const finalDate = finalDateOverride || new Date().toJSON();
    const initialDate = initialDateOverride || localStorage.getItem('lastDateInformZ')
      || moment(new Date()).format('YYYY-MM-DD');
    let settlementBusinessCode = business_code;
    let settlementBranchCode = selectedBranch;
    const codeParthner = localStorage.getItem('codeParthner');
    if (codeParthner) {
      const parsedPartner = JSON.parse(codeParthner);
      settlementBusinessCode = parsedPartner.business_code;
      settlementBranchCode = parsedPartner.branchoffice_code;
    }
    const timestamp = moment(finalDate).utc().format('YYYYMMDDTHHmmss');
    const orderReference = `inform-z-${settlementBusinessCode}-${settlementBranchCode}-${timestamp}`
      .slice(0, 128);
    return {
      minDate: initialDate,
      maxDate: finalDate,
      actualDate,
      user_code: user.user_code ?? 0,
      business_code: settlementBusinessCode,
      branchoffice_code: settlementBranchCode,
      payment_integration_id: KINPOS_INTEGRATION_ID,
      order_reference: orderReference,
    };
  };
  getSettlementContextRef.current = getSettlementContext;

  //Functions to show and hide the modal 
  const handleCloseModal = () => setModalShow(false);
  const handleShowModal = () => setModalShow(true)

  //Functions to show and hide the modal 
  const handleCloseModalDetail = () => setModalShowDetail(false);
  const handleShowModalDetail = () => setModalShowDetail(true)


  //Hool of webhsocket 
  //Hook of the webhook of evertech transactions place to play 
  useEffect(() => {
    // Connection with the sockets server
    const socket = Socket({ "machine_code": machine.code, "branchoffice_code": branchoffice_code });
    //We listen the settle request event 
    socket.on(`settle`, async (data) => {
      let initialDate, finalDate, settleSuccess = false;

      //We check the lastDate of the inform z
      if (localStorage.getItem('lastDateInformZ') === null) {
        initialDate = moment(new Date()).format('YYYY-MM-DD');
        finalDate = new Date().toJSON();
      } else {
        initialDate = localStorage.getItem('lastDateInformZ');
        finalDate = new Date().toJSON();
      }

      LoadingAlert('Espere por favor, haciendo cierre de transacciones...')
      let generalData = localStorage.getItem('generalData');
      let generalDataParse = JSON.parse(generalData);

      //We create the settle data to send to the server
      let dataSettle = {
        "informz": "true",
        "machine_code": machine.code,
        "business_code": JSON.parse(localStorage.getItem('business')).code,
        "minDate": initialDate,
        "maxDate": finalDate,
      }
      const socketSettlementContext = getSettlementContextRef.current(initialDate, finalDate);

      if (isKinposIntegrationId(data.paymentmethod_integration_id)) {
        ErrorAlert(
          'El cierre KinPOS debe iniciarse manualmente desde Reportes en el dispositivo PAX.',
          'Cierre KinPOS no iniciado',
          'warning'
        );
        return;
      }

      //We check wich payment integration evertech the user want to make the settle
      if (data.paymentmethod_integration_id === 6) {
        let evertec = generalDataParse[0].data.paymentMethods.filter(({ integration_id }) => integration_id === 6);
        //We check if the evertec array have data
        if (evertec.length > 0) {
          //We call the api to make the settle
          try {
            //We call the payment operation to make the settle
            let response = await PaymentOperations({
              operationType: 'settle', integrationType: 'Evertech', params: evertec[0].params,
              sECRStationID: generalDataParse[0].data.machine.code,
              sCashierID: generalDataParse[0].data.machine.code, sRefNumber: 0, tips: 0
            });

            //We check if the response is success
            if (response && response.data && response.data.approval_code === "00") {
              console.log("Cierre de evertech", response);
              //We add the data that we want to update
              dataSettle.voucher = response.data.receipt_output.settle;
              dataSettle.paymentmethod_integration_id = 6;
              //We show the success alert
              ErrorAlert('', 'Cierre de evertech exitoso', 'success');
              settleSuccess = true;
            } else {
              console.log("Error en el cierre de evertech", response);
              //We show the error alert
              ErrorAlert('', 'Error en el cierre de evertech', 'error')
            }
          } catch (err) {
            console.log(err);
            ErrorAlert('', 'Error en el cierre de evertech', 'error')
          }
        }
      }

      //We check payment integration banesco
      if (data.paymentmethod_integration_id === 4) {
        let banesco = generalDataParse[0].data.paymentMethods.filter(({ integration_id }) => integration_id === 4);
        //We check if the banesco array have data
        if (banesco.length > 0) {
          //We call the api to make the settle
          try {
            //We call the payment operation to make the settle
            let response = await PaymentOperations({
              operationType: 'settle', integrationType: 'Banesco', params: banesco[0].params
            });

            //We check if the response is success
            if (response && response.data && response.data.ResponseCode === "00") {
              console.log("Cierre de banesco", response);
              //We add the data that we want to update
              dataSettle.voucher = response.data.BatchTotals;
              dataSettle.paymentmethod_integration_id = 4;
              //We show the success alert
              ErrorAlert('', 'Cierre de banesco exitoso', 'success');
              settleSuccess = true;
            } else {
              console.log("Error en el cierre de banesco", response);
              //We show the error alert
              ErrorAlert('', 'Error en el cierre de banesco', 'error')
            }
          } catch (err) {
            console.log(err);
            ErrorAlert('', 'Error en el cierre de banesco', 'error')
          }
        }
      }

      //If the payment integration is not evertech or banesco we just do the settle
      if (isGenericSettlementIntegrationId(data.paymentmethod_integration_id)) {
        dataSettle.paymentmethod_integration_id = data.paymentmethod_integration_id;
        dataSettle.voucher = "0"
        settleSuccess = true;
      }
      //If the settle was success we call the api to update the orders inform z
      if (settleSuccess) {
        try {
          const registration = await updateOrdersInformZRef.current(
            dataSettle.voucher,
            dataSettle.paymentmethod_integration_id,
            socketSettlementContext
          );
          if (registration.success) {
            ErrorAlert('', 'Cierre de transacciones exitoso', 'success');
          }

        } catch (err) {
          //We show the error alert 
          ErrorAlert('', 'Error en el cierre de transacciones', 'error')
        }
      }
    });
    return () => {
      socket.disconnect();
    }

  }, []);

  //Function to gen the empty card to the transaction history 
  const EmptyCard = () => {
    return (
      <div className="m-3 w-auto ">
        <div className="border-history d-flex justify-content-md-center py-4 px-4 " aria-current="true">
          <div className="d-flex w-100 justify-content-center align-items-center  flex-column">
            <img src={empty} alt="Vacio" width="35px" height="35px" />
            <div className='text-center mt-3'>
              <h5>Vacío</h5>
              <h6 className="mb-0 text-secondary fw-bold">No hay transacciones </h6>
            </div>
          </div>
        </div>
      </div>
    )
  }


  //Function to get order by id (order_id)
  const getOrderById = async (order_id) => {
    try {
      const response = await OrdersFetchAPI.getOrderById(order_id, token);
      setDetailOrder(response.data.order)
      console.log(detailOrder)
      setOrderType("permanent")
    } catch (err) {
      setDetailOrder({})
      setOrderType("permanent")
      console.log(err)
    }
  }

  //Function to populate the order details (modal)
  const detailOrderList = () => {
    return detailOrder === undefined ? "" : <OrderDetails pos={true} orderData={detailOrder} order_type={order_type} business_data={userBusiness} setLoad={setReLoad} />
  }

  //Function to populate the list orders 
  const listOrders = () => {

    const listOrders = branchOrdersData.map((data) => (
      <>
        <div className='col-md-6' onClick={async () => {
          await getOrderById(data._id);
          handleShowModalDetail();
        }}>
          <TransactionHistory data={data} />
        </div>

      </>
    ));
    //We check if the list orders has data 
    if (listOrders.length === 0) {
      return EmptyCard()
    } else {
      return (listOrders)
    }
  }

  //We get the transactions by branchoffice 
  const getTransactionsByBranchOffice = async (business_code, branchoffice_code, minDate, maxDate) => {
    let codeParthner = localStorage.getItem('codeParthner');
    let bussinesCode = business_code
    let branchCode = branchoffice_code

    if (codeParthner !== null && codeParthner !== undefined && codeParthner !== '') {
      codeParthner = JSON.parse(localStorage.getItem('codeParthner'))
      bussinesCode = codeParthner.business_code
      branchCode = codeParthner.branchoffice_code
    }

    try {
      //Variables to set the total orders
      let subtotal = 0;
      let tax = 0;
      //We call the orders of the branchoffice 
      const response = await OrdersFetchAPI.getTransactionsByBranchOfficePaymentMethodbyUser(bussinesCode, branchCode, actualDate + 'T00:00:00.000+00:00', maxDate, 0, user.id, token, true);
      console.log(response);
      //We map the orders to get the orders that not have an inform z
      let orders = response.data.orders.filter(({ inform_z }) => inform_z === false);

      orders.map((order) => {
        subtotal = (subtotal + parseFloat(order.subtotal))
        tax = (tax + parseFloat(order.tax))
      });

      //We set the total orders
      setSubtotalOrders(subtotal)
      setTaxOrders(tax)
      setTotalOrders((subtotal + tax))
      //We set the orders state
      setBranchOrdersData(orders);
      setTemporal(response.data.orders);
      setBranchAnaliticsData([response.data.analitics]);
      //We show the success alert 
      SuccessAlert()
    } catch (err) {
      //We show the error alert 
      ErrorAlert('No tiene información')
      console.log(err);
    }
  }

  //Function to make the settle of the orders
  const makeSettle = async () => {
    if (kinposPaymentBridge.hasPendingPayment()) {
      ErrorAlert(
        'Ya existe una operacion KinPOS pendiente. No inicies otro cierre.',
        'Operacion KinPOS en proceso',
        'warning'
      );
      return;
    }
    LoadingAlert('Espere por favor...')
    //We check the machine info on the general data and verify if the machine have some payment method with evertec
    if (generalData !== null) {
      let generalDataParse = JSON.parse(generalData);
      const paymentMethods = generalDataParse?.[0]?.data?.paymentMethods || [];
      const settlementContext = getSettlementContext();

      //We filter the payment methods with evertec
      let evertec = paymentMethods.filter(({ integration_id }) => integration_id === 6);

      //We filter the payment method with banesco 
      let banesco = paymentMethods.filter(({ integration_id }) => integration_id === 4);
      const hasKinpos = paymentMethods.some(({ integration_id }) => isKinposIntegrationId(integration_id));
      if (hasKinpos) {
        if (kinposCloseInvocationInProgress) {
          ErrorAlert(
            'Ya se esta iniciando un cierre KinPOS. No repitas el cierre.',
            'Cierre KinPOS en proceso',
            'warning'
          );
          return;
        }
        kinposCloseInvocationInProgress = true;
      }

      //We check if the evertec array have data
      if (evertec.length > 0) {
        //We call the api to make the settle
        try {
          //We call the payment operation to make the settle
          let response = await PaymentOperations({
            operationType: 'settle', integrationType: 'Evertech', params: evertec[0].params,
            sECRStationID: generalDataParse[0].data.machine.code,
            sCashierID: user.id, sRefNumber: 0, tips: 0
          });

          //We check if the response is success
          if (response && response.data && response.data.approval_code === "00") {
            console.log("Cierre de evertech", response);
            //We update the orders inform z of evertech
            await updateOrdersInformZ(
              response.data.receipt_output.settle,
              6,
              settlementContext,
              { finalize: false, showSuccess: false }
            )
          } else {
            console.log("Error en el cierre de evertech", response);
            //We show the error alert
            ErrorAlert('', 'Error en el cierre de evertech', 'error')
          }
        } catch (err) {
          console.log(err);
          ErrorAlert('', 'Error en el cierre de evertech', 'error')
        }
      }

      //We check if the banesco array have data
      if (banesco.length > 0) {
        //We call the api to make the settle
        try {
          //We call the payment operation to make the settle
          let response = await PaymentOperations({
            operationType: 'settle', integrationType: 'Banesco', params: banesco[0].params
          });

          //We check if the response is success
          if (response && response.data && response.data.ResponseCode === "00") {
            console.log("Cierre de banesco", response);
            //We update the orders inform z of banesco
            await updateOrdersInformZ(
              response.data.BatchTotals,
              4,
              settlementContext,
              { finalize: false, showSuccess: false }
            )
          } else {
            console.log("Error en el cierre de banesco", response);
            //We show the error alert
            ErrorAlert('', 'Error en el cierre de banesco', 'error')
          }
        } catch (err) {
          console.log(err);
          ErrorAlert('', 'Error en el cierre de banesco', 'error')
        }
      }

      if (hasKinpos) {
        try {
          LoadingAlert('Cierre KinPOS en proceso', 'Complete el cierre en el dispositivo PAX.');
          await kinposPaymentBridge.closeBatch({
            orderReference: settlementContext.order_reference,
            context: settlementContext,
          });
          kinposCloseInvocationInProgress = false;
          syncKinposClosePending();
        } catch (err) {
          kinposCloseInvocationInProgress = false;
          syncKinposClosePending();
          ErrorAlert(
            err?.message || 'No se pudo iniciar el cierre KinPOS/PAX.',
            'Error iniciando cierre KinPOS',
            'error'
          );
        }
        return;
      }

      //We update the other orders to inform z
      await updateOrdersInformZ(null, null, settlementContext)

    }
  }

  //Function to make report detailed banesco 
  const makeReportDetailedBanesco = async () => {
    LoadingAlert('Espere por favor...');
    let generalData = localStorage.getItem('generalData');
    let generalDataParse = JSON.parse(generalData);
    let banesco = generalDataParse[0].data.paymentMethods.filter(({ integration_id }) => integration_id === 4);
    //We check if the banesco array have data
    if (banesco.length > 0) {
      //We call the api to make the settle
      try {
        //We call the payment operation to make the settle
        let response = await PaymentOperations({
          operationType: 'reportDetail', integrationType: 'Banesco', params: banesco[0].params
        });

        //We check if the response is success
        if (response && response.data && response.data.ResponseCode === "00") {
          console.log("Reporte detallado de banesco", response);
          //We show the modal with the report
          SuccessAlert()
        } else {
          console.log("Error en el reporte detallado de banesco", response);
          //We show the error alert
          ErrorAlert('', 'Error en el reporte detallado de banesco', 'error')
        }
      } catch (err) {
        console.log(err);
        ErrorAlert('', 'Error en el reporte detallado de banesco', 'error')
      }
    }
  }

  //Function to make settlement report 
  const makeSettlementReport = async () => {
    LoadingAlert('Espere por favor...');
    let generalData = localStorage.getItem('generalData');
    let generalDataParse = JSON.parse(generalData);
    let banesco = generalDataParse[0].data.paymentMethods.filter(({ integration_id }) => integration_id === 4);
    //We check if the banesco array have data
    if (banesco.length > 0) {
      //We call the api to make the settle
      try {
        //We call the payment operation to make the settle
        let response = await PaymentOperations({
          operationType: 'settleReport', integrationType: 'Banesco', params: banesco[0].params
        });

        //We check if the response is success
        if (response && response.data && response.data.ResponseCode === "00") {
          console.log("Reporte settle de banesco", response);
          //We show the modal with the report
          SuccessAlert()
        } else {
          console.log("Error en el reporte settle de banesco", response);
          //We show the error alert
          ErrorAlert('', 'Error en el reporte settle de banesco', 'error')
        }
      } catch (err) {
        console.log(err);
        ErrorAlert('', 'Error en el reporte settle de banesco', 'error')
      }
    }
  }
  //Function to update the orders inform z
  const updateOrdersInformZ = async (
    informZResponseVoucher,
    paymenthod_integration_id,
    settlementContext = getSettlementContext(),
    options = {}
  ) => {
    const {
      finalize = true,
      showSuccess = true,
      showError = true,
      allowNoOrders = false,
      displayVoucher = informZResponseVoucher,
    } = options;
    const finishSettlement = () => {
      if (!finalize) return;
      const dateArray = settlementContext.maxDate.split("T");
      localStorage.setItem('lastDateInformZ', `${dateArray[0]}T00:00:00.000Z`);
      if (showSuccess) ErrorAlert('', 'Se realizo el cierre con exito', 'success');
      setModalInformZSettleInfo(displayVoucher);
      setModalInformZSettle(true);
      getTransactionsByBranchOffice(
        settlementContext.business_code,
        settlementContext.branchoffice_code,
        minDate,
        maxDate
      );
    };
    try {
      let data = {
        "informz": "true",
        "user_code": settlementContext.user_code,
        "business_code": settlementContext.business_code,
        "minDate": settlementContext.minDate,
        "maxDate": settlementContext.maxDate,
        "voucher": informZResponseVoucher !== undefined && informZResponseVoucher !== null ? informZResponseVoucher : null
      }
      //We check if the payment method integration id is not null
      if (paymenthod_integration_id !== undefined && paymenthod_integration_id !== null) {
        data.paymenthod_integration_id = paymenthod_integration_id
      }
      //We call the api to update the orders inform z
      const response = await OrdersFetchAPI.updateOrderStatusinformZ(
        settlementContext.actualDate,
        settlementContext.maxDate,
        false,
        settlementContext.user_code,
        settlementContext.business_code,
        settlementContext.branchoffice_code,
        token,
        data
      );
      finishSettlement();
      return { success: true, response };
    } catch (err) {
      const noOrdersFound = isKinposEmptyInformZError(err);
      if (allowNoOrders && noOrdersFound) {
        finishSettlement();
        return { success: true, noOrders: true };
      }
      if (showError) ErrorAlert('', 'Error en el cierre', 'error')
      console.log(err);
      return { success: false, error: err };
    }
  }
  updateOrdersInformZRef.current = updateOrdersInformZ;

  const handleKinposCloseResult = async (result) => {
    if (result.operation && result.operation !== "close") return;
    const activeClose = kinposPaymentBridge.getPendingPayment();
    if (
      !isKinposClosePending(activeClose)
      || activeClose.request_id !== result.request_id
    ) {
      syncKinposClosePending();
      return;
    }
    syncKinposClosePending();

    if (result.status === "pending") return;
    if (result.status === "uncertain") {
      ErrorAlert(
        'No se pudo confirmar el resultado. No repitas KP_Close; SmartPay reintentara recovery.',
        'Cierre KinPOS pendiente',
        'warning'
      );
      return;
    }

    if (result.status !== "approved" || result.success !== true) {
      await ErrorAlert(
        result.message || 'KinPOS no aprobo el cierre.',
        result.status === "cancelled" ? 'Cierre KinPOS cancelado' : 'Cierre KinPOS no aprobado',
        result.status === "cancelled" ? 'warning' : 'error'
      );
      kinposPaymentBridge.complete(result.request_id);
      syncKinposClosePending();
      return;
    }

    const closeRecord = toKinposCloseRecord(result);
    const settlementContext = result.request?.context;
    if (!closeRecord || !settlementContext) {
      kinposPaymentBridge.markProcessingFailed(result.request_id);
      syncKinposClosePending();
      ErrorAlert(
        'KinPOS aprobo el cierre, pero falta el contexto para registrar el Informe Z. No repitas el cierre.',
        'Cierre KinPOS aprobado pendiente de registro',
        'warning'
      );
      return;
    }

    kinposPaymentBridge.markAwaitingRegistration(result.request_id);
    LoadingAlert('Registrando cierre KinPOS', 'Espere mientras SmartPay registra el Informe Z.');
    const kinposRegistration = await updateOrdersInformZ(
      closeRecord.voucher,
      KINPOS_INTEGRATION_ID,
      settlementContext,
      {
        finalize: false,
        showSuccess: false,
        showError: false,
        allowNoOrders: true,
      }
    );
    if (!kinposRegistration.success) {
      kinposPaymentBridge.markProcessingFailed(result.request_id);
      syncKinposClosePending();
      ErrorAlert(
        'El cierre KinPOS fue aprobado, pero el backend no registro el Informe Z. No repitas el cierre.',
        'Cierre KinPOS aprobado pendiente de registro',
        'warning'
      );
      return;
    }

    const remainingRegistration = await updateOrdersInformZ(
      null,
      null,
      settlementContext,
      {
        finalize: true,
        showSuccess: false,
        showError: false,
        allowNoOrders: true,
        displayVoucher: closeRecord.voucher,
      }
    );
    if (!remainingRegistration.success) {
      kinposPaymentBridge.markProcessingFailed(result.request_id);
      syncKinposClosePending();
      ErrorAlert(
        'El cierre KinPOS fue aprobado, pero SmartPay no completo el Informe Z. No repitas el cierre.',
        'Cierre KinPOS aprobado pendiente de registro',
        'warning'
      );
      return;
    }

    kinposPaymentBridge.complete(result.request_id);
    const closeRemainsPending = syncKinposClosePending();
    if (!closeRemainsPending) {
      ErrorAlert('', 'Cierre KinPOS registrado con exito', 'success');
    } else {
      ErrorAlert(
        'El Informe Z fue registrado, pero Android no confirmo el ACK. SmartPay reintentara solamente el ACK.',
        'ACK KinPOS pendiente',
        'warning'
      );
    }
  };

  kinposCloseResultHandlerRef.current = handleKinposCloseResult;

  useEffect(() => kinposPaymentBridge.subscribe(
    "close",
    (result) => kinposCloseResultHandlerRef.current?.(result)
  ), []);

  useEffect(() => {
    const pendingClose = kinposPaymentBridge.getPendingPayment();
    if (!isKinposClosePending(pendingClose)) {
      syncKinposClosePendingRef.current();
      return;
    }
    syncKinposClosePendingRef.current();
    Promise.resolve(kinposPaymentBridge.recover())
      .finally(() => syncKinposClosePendingRef.current());
  }, []);

  const closeButtonPending = kinposClosePending
    && isKinposClosePending(kinposPaymentBridge.getPendingPayment());



  //Function to search any result on the search filter 
  function handleChangeFiltro(event) {
    let resultFilter = [];
    if (event.target.value == "") {
      console.log(event.target.value);
      setBranchOrdersData(temporal);
    } else {
      for (
        let recorrer = 0;
        recorrer < branchOrdersData.length;
        recorrer++
      ) {
        const examinar = branchOrdersData[recorrer];

        const info = JSON.stringify(examinar);
        const resultado = info
          .toLowerCase()
          .includes(event.target.value.toLowerCase());

        if (resultado == true) {
          resultFilter.push(examinar);

          setBranchOrdersData(resultFilter);
          console.log(resultFilter);
        }
      }
    }
  }

  const reportDetail = (general_sales) => {
    return <ReportTable table_name="Tabla de ventas detalladas" table_headers={["Fecha", "Hora", "Orden", "Total", "Itbms", "Descuento"]} table_type="general_report" table_data={general_sales} />

  }


  //Hook to charge data when the page is loaded 
  useEffect(() => {
    (async () => {
      try {
        // valid token

        try {
          await validSession()
        } catch (err) {
          console.log(err);
        }
        //We set the branchoffices of the user 
        setUserBranchs(user.branchoffices);
        setUserBusiness(user.business);
        //We search the branch orders 
        getTransactionsByBranchOffice(business_code, selectedBranch, actualDate, maxDate)
      } catch (err) {
        console.log(err);
      }
    })();
  }, []);


  return (
    <>

      <header className="py-1 px-1  border-bottom  bg-white fixed-top">
        <nav className="border-bottom border-3 bg-white px-1 fixed-top ">
          <div className='d-flex  align-items-center justify-content-between'>
            <div>
              <a href="javascript:location.reload()"
                className="d-flex align-items-center 
                            flex-fill bd-highlight 
                            text-dark text-decoration-none">
                <img
                  className="navbar-logo-post"
                  src={logo_sp} alt="Logo Smart Pay" />
                <span className="h5 pt-2 me-3 fw-bold align-self-center text-uppercase">POS</span>
              </a>
            </div>
            <Navbar />
          </div>
        </nav>
      </header>


      <div className="container">
        <div className='smart-pay-main'>
          <div className='d-flex justify-content-center'>
            <h2 className='fs-2 fw-bold'>Analíticas </h2>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className='col-12 col-md-12 col-xl-8 col-lg-6 ' hidden>
            <div className='row justify-content-md-center'>
              <h4> Filtro </h4>
              <div className="col-12 col-md-12 col-xl-8 col-lg-12 ">
                <div className="border rounded-sp p-3 bg-white card-stats mb-xl-0">
                  {/* <div>
                    <h6>Sucursal</h6>
                   <div className="login-form needs-validation">
                      <div className="row">
                        <div className="col-12">
                          <div className="">
                      
                            <select onChange={e => setSelectedBranch({ code: e.target.value })} className='form-select' name="user_branch" id="user_branch">
                              <option value={0}>Mostrar todos</option>
                              {branchList()}
  </select>
                          </div>
                        </div>
                      </div>
                    </div> 
                  </div>*/}
                  <div className='mt-3'>
                    <h6>Fecha</h6>
                    <div className="login-form needs-validation">
                      <div className="row">
                        <div className="col-8">
                          <div className="">
                            <input
                              onChange={(e) => setMinDate(e.target.value)}
                              type="date" name="date" id="" className="control mt-3" />
                          </div>
                        </div>
                        <div className="col-4">
                          <button className="btn btn-success rounded mt-3" onClick={e => getTransactionsByBranchOffice(business_code, selectedBranch, minDate, `${minDate}T23:59:59.000+00:00`)} id="btn-analitycs">Aceptar</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-10 col-md-12 col-xl-12 col-lg-12 '>
            <h4 className='text-center'> Historial de transacciones  </h4>

            <div className="w-auto bg-light px-1 py-2 border rounded mt-4">
              <div className="border-0" >
                {/* <i className="uil uil-money-stack"></i> */}
                <div className="d-flex justify-content-between align-items-center">
                  <h6 className="m-3 text-secondary fw-bold">Buscador</h6>
                  <div className='border-0 fw-bold fs-3'>
                    <input
                      spellcheck="false"
                      className="form-control"
                      type="text"
                      step="any"
                      onChange={handleChangeFiltro}
                      placeholder="Buscar orden "
                    />

                  </div>
                </div>
              </div>
            </div>

            <div className='transaction-wrapper-3 border border-historyoverflow-hidden '>
              <div className="row overflow-hidden">
                {listOrders()}
              </div>
              {/* 3 */}
              <div className='d-flex justify-content-between mt-2'>
                <h5><strong>Total de ventas:</strong></h5>
                <h5><strong>${parseFloat(totalOrders).toFixed(2)}</strong></h5>
              </div>

              <button
                className='btn btn-danger m-2'
                disabled={closeButtonPending}
                onClick={() => makeSettle()}
              >
                {closeButtonPending ? 'Cierre KinPOS en proceso' : 'Cierre'}
              </button>

              <button className='btn btn-info m-2' onClick={() => makeReportDetailedBanesco()}>
                Auditoria
              </button>

              <button className='btn btn-info m-2' onClick={() => makeSettlementReport()}>
                Reporte de cierre
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <Modal className="modal-lg" show={modalShow} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Detalles</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          {reportDetail(ordersPaymentMethod)}

        </Modal.Body>
      </Modal>


      {/* Modal detail order */}
      <Modal show={modalShowDetail} onHide={handleCloseModalDetail}>
        <Modal.Header closeButton>
          <Modal.Title>Detalles</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {detailOrderList()}
        </Modal.Body>
      </Modal>

      {/* Modal inform z settle */}
      <Modal show={modalInformZSettle} onHide={() => setModalInformZSettle(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Información</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex alight-item-center justify-content-center">
            <RenderIf isTrue={modalInformZSettleInfo !== null}>
              <div>
                <pre>{modalInformZSettleInfo}</pre>
              </div>
            </RenderIf>

            <RenderIf isTrue={modalInformZSettleInfo === null}>
              <div>
                <pre>No se genero voucher</pre>
              </div>
            </RenderIf>

          </div>
          <div className="d-flex justify-content-center">
            <button className="btn btn-info" onClick={() => setModalInformZSettle(false)}>Cerrar</button>
          </div>
        </Modal.Body >
      </Modal >
    </>
  )

}
export default AnaliticsPayment
